import { useState } from 'react';

interface InputContainerWithInlineLabelProps {
  children: JSX.Element[];
  inlineLabel?: string;
}
export const InputContainerWithInlineLabel = ({
  children,
  inlineLabel,
}: InputContainerWithInlineLabelProps) => {
  const [focus, setFocus] = useState(false);

  return (
    <div
      className={`h-[44px] flex items-center border border-gray-light rounded-md mt-1 text-gray-text ${
        inlineLabel ? 'w-[200px]' : 'w-[160px]'
      } ${focus && 'border-purple-normal'} 
      `}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
    >
      {inlineLabel && (
        <span className={`text-center font-medium text-base mx-2`}>
          {inlineLabel}
        </span>
      )}

      {children}
    </div>
  );
};
